export default function isTypedObjectKey<T extends object>(key: unknown, obj: T): key is keyof T {
  // We're relying on runtime validation here
  // eslint-disable-next-line local/no-new-type-assertions
  return typeof key === 'string' && Object.hasOwn(obj, key)
}

/**
 * The problem we're trying to solve:
 * const obj: Record<UserRole, string> = {}
 * const value1 = ((): string => 'admin')()
 *
 * obj[value1] = 'some value'
 * ^ Error: Element implicitly has 'any' type because expression of type 'string' can't be used to index type 'Record<UserRole, string>'
 *
 * How to fix:
 * const obj: Record<UserRole, string> = {}
 * const value2 = ((): string => 'admin')()
 *
 * if (isTypedObjectKey(value2, USER_ROLES_RECORD)) {
 *   obj[value2] = 'some value'
 * }
 * ^ No error
 */
